export class Abort {
  constructor(operation) {
    this.message = `${operation} aborted`;
  }
}
